import './global';
import './hash';
import './popup-manager';
import './ajax-manager';
import './form-manager';
import './header';
import './menu';
import './accordion';
import './text-image';
import './slider';
import './home-slider';
import './gallery';
import './jobs-listing';
import './popups';
import './forms';
import './articles-listing';

import '../scss/theme.scss';